import React from "react";

import DescriptionSvg from "../../assets/images/icons/description.svg";

export const DescriptionIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={DescriptionSvg}
        alt={alt || "Description"}
    />
);
